// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__Fjwy4","sendOtp":"AuthorizeToLogin_sendOtp__2yiqU"};